export const contactOptions = {
  PREFERRED_PHONE: 'PREFERRED_PHONE',
  OTHER_PHONE: 'OTHER_PHONE',
  EMAIL: 'EMAIL',
};
